module.exports = {
  title: 'Spotify Roadtrip',
  description: `
    Have you ever gone on a road trip with some friends and wanted to have a shared playlist, but get tired of hearing the same person's songs in a row because of the standard "shuffle" mode?
    This app was made specifically to solve that problem on Spotify by sorting playlists by user; like a deck of cards.
  `,
  tags: ['Angular', 'CSS', 'Design', 'Express', 'JavaScript', 'Node', 'Spotify API'],
  images: [require('./images/1.png'), require('./images/2.png'), require('./images/3.png')],
};



// WEBPACK FOOTER //
// ./src/data/works/spotifyroadtrip/index.js